/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBrainScan = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M11.677 2c4.545 0 7.863 3.663 8.31 8H22v2h-1.288l1.106 2.072.014.025.012.025c.38.817.046 1.8-.772 2.206l-.002.001-1.026.506v1.815c0 .462-.239.814-.527 1.022a1.682 1.682 0 0 1-.671.274c-.332.063-.708.054-.846.054h-3v2h-2v-2c0-.724.248-1.365.842-1.728C14.324 17.976 14.864 18 15 18h3l.044-.001v-1.364c0-.632.355-1.217.928-1.5l.907-.449L18.443 12H16a1 1 0 0 1-.894-.553L14.07 9.375l-2.151 5.019a1 1 0 0 1-1.867-.078L9 11.161l-.052.155A1 1 0 0 1 8 12H5.122c.303 1.529 1.152 2.966 2.242 3.986l.279.248.034.028.03.031 1.4 1.4-1.137 4.55-1.94-.485.863-3.451-.586-.586C4.71 16.359 3.432 14.28 3.09 12H2v-2h1.038c.4-4.472 4.1-8 8.639-8zm0 2C8.27 4 5.44 6.61 5.047 10H7.28l.773-2.316a1 1 0 0 1 1.835-.147l.061.147 1.17 3.506 1.963-4.584a1 1 0 0 1 1.74-.177l.074.124L16.618 10h1.362c-.432-3.39-3.03-6-6.303-6z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgBrainScan as BrainScan };
